import React from "react";
import Cookies from "universal-cookie";
import PaymentOptionCard from './PaymentOptionCard'
import '../../../App.css';


const cookies = new Cookies();
class PaymentDashboard extends React.Component {
    render() {
        const goBack = () => {
            if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1')
                window.location.href = "/doctor-dashboard"
            else
                window.location.href = "/"
        }

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1') {
            return (
                <div className="Doctor-dashboard-div" style={{ color: '#2E5266FF' }}>
                    <div className="Doctor-dashboard-heading">
                        <div style={{ fontSize: 56 }}>نافذة الدفع الآمن</div>
                        <h4>.يمكنك من هذه النافذة دفع الغرامات والمستحقات المترتبة من قبل نقابة الاطباء</h4>
                    </div>
                    <h2 style={{marginTop:30}}>اختر آلية الدفع</h2>
                    <div className="Payment-options" >

                        {/* ZAIN CASH */}
                        <PaymentOptionCard to="/visa-master-payment" name="كي كارد" img="https://dl-media.viber.com/3/share/2/long/vibes/icon/image/0x0/4738/f4534fe942dceeaa5b0b4aac9e52d9665db92648f97c14c7012a3958436d4738.jpg" width="100" height="100" />
                        <PaymentOptionCard to="/zaincash-payment" name="اسيا حوالة" img="https://scontent.fbgw41-3.fna.fbcdn.net/v/t1.6435-9/56806455_2395174313827607_6378825165333069824_n.png?_nc_cat=104&ccb=1-5&_nc_sid=09cbfe&_nc_eui2=AeHv3lqOLklCIBZQMtmJUizO8iRzg9StiYPyJHOD1K2Jg32JBREV7-3vlyPjxdxoQ0i5USUj2n-JnC3no4PYn41B&_nc_ohc=Ny6qhctRIvUAX8dJtyH&_nc_ht=scontent.fbgw41-3.fna&oh=00_AT-S8PsBv731fcDNm2jtisThJBX5mM3IGsNnBSjHWwCnrg&oe=625BC7D3" width='100' height="100" />
                        <PaymentOptionCard to="/zaincash-payment" name="زين كاش" img="https://mobileapi.zaincash.iq/logo.png" width='150' height="100" />

                    </div>
                    <div className="Payment-options" >
                        <PaymentOptionCard to="/visa-master-payment" name="بايبال" img="https://sedberkdesign.com/wp-content/uploads/2020/06/kisspng-paypal-logo-brand-font-payment-paypal-logo-icon-paypal-icon-logo-png-and-vecto-5b7f273e45e8a9.9067728615350597742864.png" width="130" height="130" />
                        <PaymentOptionCard to="/visa-master-payment" name="فيزا كارد" img="https://logowik.com/content/uploads/images/857_visa.jpg" width="140" height="120" />
                        <PaymentOptionCard to="/visa-master-payment" name="ماستر كارد" img="https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/072016/untitled-1_137.png?itok=_QrtgEVI" width="100" height="100" />
                    </div>
                    <div onClick={() => goBack()} className="Doctor-dashboard-footer">
                        <div style={{ fontSize: 16,textAlign:'end' }}>الرجوع</div>
                    </div>
                </div>

            );
        } else {
            window.location.href = "/"
        }
    }
}


export default PaymentDashboard;
